import styled from 'styled-components';
import { colors, fontSizes, spacing } from 'ui/theme';
import { PopoverContent, PopoverTrigger } from 'ui/popover';
import { pxToRem } from 'utils/convert';
import { SecondaryButton } from 'ui/button';
import { SecondaryPageHeader } from 'ui/pageHeader';

const customSpacing = {
  p430: pxToRem(430),
  p893: pxToRem(893),
};

export const MonitorPageActionsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const MonitorPageActionWrapper = styled.div`
  margin-left: ${spacing.half};
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  gap: 0;
`;

export const StyledEditIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing.half};
`;

export const StyledSecondaryPageHeader = styled(SecondaryPageHeader)`
  [data-page-header-content] > *:first-child {
    overflow: hidden;
    max-width: ${customSpacing.p893};
  }
`;

export const ExperimentHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const PopoverDetail = styled.div`
  color: ${colors.grey80};
`;

export const PopoverRow = styled(PopoverDetail)`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-top: ${spacing.half};
  font-size: ${fontSizes.s14};
`;

export const CampaignLink = styled.a`
  color: ${colors.purple90};
`;

export const StyledPopoverContent = styled(PopoverContent)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  margin: ${spacing.half};
  word-break: break-all;
  filter: drop-shadow(0px 16px 24px rgb(0 0 0 / 0.06));
  &:focus-visible {
    outline: none;
  }
`;

export const StyledTrigger = styled(PopoverTrigger)`
  max-width: ${customSpacing.p430};
  text-overflow: ellipsis;
  overflow: hidden;
  &:focus-visible {
    outline: none;
  }
`;

export const IconWrapper = styled.div`
  color: ${colors.grey60};
  padding-right: ${spacing.eighth};
  display: flex;
  align-items: center;
`;
